import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import SectionTitle from 'UI/components/SectionTitle';
import Animated from 'UI/containers/Animated';
import { REVEAL_ANIMATION_PROPS } from 'utils/constants';

import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import CallToAction from 'UI/components/CallToAction';
import useSectionProps from './utils/useSectionProps';
import styles from './styles.module.scss';

const Table = dynamic(() => import('components/Common/Table'));

const TableSectionNew = (props) => {
  const {
    title,
    description,
    subtitle,
    view,
    type,
    tableContent,
    ctaLink,
    handleOnCTAClick,
  } = useSectionProps(props);

  return (
    <section className={cn(styles.tableSection, styles[type], styles[view])}>
      <div className={styles.contentWrapper}>
        <SectionTitle
          title={title}
          subtitle={subtitle}
          description={description}
          titleStyle={styles.titleStyle}
        />
        {tableContent && (
          <Animated {...REVEAL_ANIMATION_PROPS}>
            <div className={styles.tableWrapper}>
              <ContentfulParser document={tableContent} />
            </div>
          </Animated>
        )}
        {ctaLink && (
          <Animated
            {...REVEAL_ANIMATION_PROPS}
            transitionDelay={50}
          >
            <CallToAction
              data={ctaLink}
              handleOnClick={handleOnCTAClick}
              className={styles.callToAction}
              pageType={type}
            />
          </Animated>
        )}
      </div>
    </section>
  );
};

TableSectionNew.propTypes = {
  section: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string.isRequired,
};

export default TableSectionNew;
